import { render } from "./AnimatedHotCupScreen.vue?vue&type=template&id=4b177164&scoped=true&ts=true"
import script from "./AnimatedHotCupScreen.vue?vue&type=script&lang=ts"
export * from "./AnimatedHotCupScreen.vue?vue&type=script&lang=ts"

import "./AnimatedHotCupScreen.vue?vue&type=style&index=0&id=4b177164&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b177164"]])

export default __exports__